module.exports = {
      id: "Mail-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/landing/sprite.svg#Mail-usage",
      toString: function () {
        return this.url;
      }
    }